import { SvgIconType } from './svg.interface';

const LogoHeader: SvgIconType = ({
  width = 114,
  height = 38,
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 451 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9297 17.4428C27.0807 15.0145 26.9297 12.5139 27.4447 10.1759C28.9455 3.44161 35.5436 -0.891435 42.2923 0.155719C49.3521 1.25704 54.0853 7.12471 53.7122 14.3374C53.3392 21.5953 48.0289 27.0387 40.9959 27.2734C37.9233 27.3727 34.8507 27.2734 31.7783 27.3004C27.9243 27.3366 26.8053 28.4649 26.7344 32.3196C26.6723 35.9304 26.8497 39.5594 26.459 43.1341C25.6599 50.4913 19.4171 55.402 12.0732 54.7791C4.72937 54.1562 -0.18135 48.2886 0.00513333 40.3718C0.173856 33.3486 5.73282 27.7969 12.8458 27.6165C15.9183 27.5351 18.9909 27.6165 22.0635 27.5893C25.722 27.5533 27.0186 26.2082 27.0718 22.4348C27.0984 20.7739 27.0718 19.1128 27.0718 17.4608H26.9297V17.4428Z"
        fill="#5456AD"
      />
      <path
        d="M54.1386 45.0028C54.1386 43.7299 54.1298 42.4662 54.1386 41.1934C54.2363 33.1952 59.8573 27.5261 67.6187 27.5984C75.1757 27.6706 80.8146 33.5201 80.7879 41.2655C80.7613 49.0017 75.2022 54.689 67.5122 54.7973C64.635 54.8424 61.7489 54.7973 58.8716 54.8154C54.9112 54.8424 53.81 55.9798 53.7479 60.0963C53.6946 63.5086 53.8544 66.9389 53.5702 70.333C53.0108 76.9409 47.9048 81.8788 41.4844 82.3302C34.7887 82.7996 29.0344 78.6922 27.4094 72.2829C25.1804 63.4814 31.2367 55.3209 40.1878 55.1131C43.2604 55.0411 46.333 55.1313 49.4054 55.0952C52.7443 55.0501 54.0409 53.7139 54.1298 50.2566C54.1742 48.4962 54.1298 46.7451 54.1298 44.9847L54.1386 45.0028Z"
        fill="#D8B8F3"
      />
      <path
        d="M122.696 58.0067V29.6565H111.762V24.371H139.756V29.6565H128.822V58.0067H122.696Z"
        fill="#081F3B"
      />
      <path
        d="M169.332 52.769H187.948V58.0067H163.205V24.371H187.288V29.6085H169.332V38.3538H185.261V43.4953H169.332V52.769Z"
        fill="#081F3B"
      />
      <path
        d="M213.63 58.0067V24.371H219.756V52.721H237.004V58.0067H213.63Z"
        fill="#081F3B"
      />
      <path
        d="M266.819 52.769H285.436V58.0067H260.693V24.371H284.776V29.6085H266.819V38.3538H282.748V43.4953H266.819V52.769Z"
        fill="#081F3B"
      />
      <path
        d="M333.507 51.2796V40.8044H339.304V54.2106C335.864 57.0456 331.056 58.487 326.389 58.487C316.162 58.487 308.623 51.2314 308.623 41.1888C308.623 31.1461 316.162 23.8904 326.484 23.8904C331.997 23.8904 336.616 25.7645 339.728 29.3682L335.864 33.2122C333.27 30.5695 330.301 29.3682 326.768 29.3682C319.745 29.3682 314.797 34.2214 314.797 41.1888C314.797 48.0121 319.745 53.0093 326.72 53.0093C329.077 53.0093 331.385 52.5289 333.507 51.2796Z"
        fill="#081F3B"
      />
      <path
        d="M394.417 58.0067H387.82L381.079 48.1562C380.655 48.2042 380.232 48.2042 379.808 48.2042H372.362V58.0067H366.235V24.371H379.808C388.478 24.371 393.852 28.8878 393.852 36.3356C393.852 41.429 391.306 45.177 386.829 46.9549L394.417 58.0067ZM387.678 36.3356C387.678 32.1071 384.898 29.6565 379.524 29.6565H372.362V43.0627H379.524C384.898 43.0627 387.678 40.5641 387.678 36.3356Z"
        fill="#081F3B"
      />
      <path
        d="M444.253 58.0067L440.954 50.2224H424.459L421.208 58.0067H414.892L429.738 24.371H435.77L450.663 58.0067H444.253ZM426.534 45.3212H438.929L432.708 30.6175L426.534 45.3212Z"
        fill="#081F3B"
      />
    </svg>
  );
};

export default LogoHeader;
